import React, { useEffect, useRef, useState } from 'react';
import { FilterIcon } from 'components/common/icons/FilterIcon';
import { SearchOverlay } from './searchOverlay/SearchOverlay/SearchOverlay';
import { HeaderActionWrapper } from '@app/components/header/Header.styles';
import { CategoryComponents } from '@app/components/header/components/HeaderSearch/HeaderSearch';
import { CategoryType } from '@app/constants/categoriesList';
import { Btn, InputSearch } from '../HeaderSearch/HeaderSearch.styles';
import { BasePopover } from '@app/components/common/BasePopover/BasePopover';

interface SearchDropdownProps {
  query: string;
  setQuery: (query: string) => void;
  data: CategoryComponents[] | null;
  isOverlayOpen: boolean;
  setOverlayOpen: (state: boolean) => void;
  selectedCategories: CategoryType[];
  setSelectedCategories: (cats: CategoryType[]) => void;
}

export const SearchDropdown: React.FC<SearchDropdownProps> = ({
  query,
  setQuery,
  data,
  isOverlayOpen,
  setOverlayOpen,
  selectedCategories,
  setSelectedCategories,
}) => {
  const [isFilterOpen, setFilterOpen] = useState(false);
  const ref = useRef<any>(null);

  useEffect(() => {
    setOverlayOpen(!!query || isFilterOpen);
  }, [query, isFilterOpen, setOverlayOpen]);

  return (
    <>
      <BasePopover
        {...((!!data || isFilterOpen) && { trigger: 'click', onOpenChange: setOverlayOpen })}
        overlayClassName="search-overlay"
        content={
          <SearchOverlay
            data={data}
            isFilterOpen={isFilterOpen}
            selectedCategories={selectedCategories}
            onCategoryChange={setSelectedCategories}
          />
        }
        open={isOverlayOpen}
        getPopupContainer={() => ref.current}
      >
        <HeaderActionWrapper>
          <InputSearch
            width="100%"
            value={query}
            placeholder="Tìm kiếm..."
            filter={
              <Btn
                size="small"
                type={isFilterOpen ? 'ghost' : 'text'}
                aria-label="Bộ lọc"
                icon={<FilterIcon />}
                onClick={() => setFilterOpen(!isFilterOpen)}
              />
            }
            onChange={(event) => setQuery(event.target.value)}
            enterButton={null}
            addonAfter={null}
          />
          <div ref={ref} />
        </HeaderActionWrapper>
      </BasePopover>
    </>
  );
};
